import { render, staticRenderFns } from "./ConvictionHomeComponent.vue?vue&type=template&id=1f72531f&scoped=true"
import script from "./ConvictionHomeComponent.vue?vue&type=script&lang=js"
export * from "./ConvictionHomeComponent.vue?vue&type=script&lang=js"
import style0 from "./ConvictionHomeComponent.vue?vue&type=style&index=0&id=1f72531f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72531f",
  null
  
)

export default component.exports